/* =====================================================================
 * Familien-Jahreszahlen-Poster Editor (PROJ-38)
 * =====================================================================
 * Reines Text-Poster (KEIN Foto, KEIN Crop, KEINE Map). Kopiervorlage
 * = geburtsposter.js (State/Live-Preview, Groessen-/Frame-Picker aus
 * target_product.variants, Cart-Add) + dynamischer Personen-Zeilen-Editor.
 *
 * PRINT-MATCH: Die Live-Vorschau spiegelt renderJahreszahlen() aus
 * citymap-server/blanket_frontend/print-mode.js 1:1 (gleiche Positionen,
 * cqw-Groessen, Zeilen-Skalierungsformel). Aendert sich der Server,
 * muss dieser Block mitgezogen werden - Werte bewusst identisch.
 *
 * Layout: 2-6 Zeilen Geburtsjahr (Serif, Preset-Farbe) mit Script-Namen
 * QUER UEBER den Ziffern (z-index 3 ueber 2, Playbook §3); Zeilen-Block
 * fuellt die obere Flaeche (flex space-evenly), Fontgroesse skaliert mit
 * der Zeilenzahl (2 wie 6 fuellen die Flaeche). Unten Herz + Familienname
 * (Versalien-Serif) + optionaler Spruch (Zeile entfaellt ohne Luecke).
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.JZ_BACKEND_API_URL || 'https://tiles.distantlines.de';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var INK = '#28292d';
  var SANS = "'Outfit', system-ui, sans-serif";
  /* Stil-Fonts Modern/Elegant/Verspielt - 1:1 vom Definitionsposter (Hauptwort).
   * MUESSEN print-mode.js entsprechen (Print-Match). Clother/Parlare via Typekit
   * sgc6idq, Playfair via Google. Parlare NUR Weight 400 (Glyphen-Bug). */
  var PW_STYLES = {
    modern:    { font: "'clother', sans-serif",              weight: 700 },
    elegant:   { font: "'Playfair Display', Georgia, serif", weight: 700 },
    verspielt: { font: "'parlare', cursive",                 weight: 400 }
  };
  var PW_LABEL = { modern: 'Modern', elegant: 'Elegant', verspielt: 'Verspielt' };
  function pwFont(s) { return PW_STYLES[s] || PW_STYLES.elegant; }
  var JZ_HEART_PATH = 'M 49.4 0 C 27 0, 0 24, 0 60 C 0 105, 58 166, 110 200 C 162 166, 220 105, 220 60 C 220 24, 193 0, 170.6 0 C 152 1, 116 16, 110 58 C 104 16, 68 1, 49.4 0 Z';
  var MAX_PERSONS = 6, MIN_PERSONS = 2;

  /* ---- Modul-State (eine Section pro -gestalten-Page) ---- */
  var root, stage, sectionId;
  var state = {
    fstyle: { year: 'modern', name: 'verspielt' },
    family: 'Familie Hofmann',
    spruch: 'Unsere Geschichte in Zahlen',
    year_color: '#e3d4bd',      // Preset Beige = Default
    c_names: '#28292d',
    c_footer: '#28292d',
    bg_color: '#ffffff',
    paper_size: '30x40',
    variant_id: '',
    product_type: '',
    frame_color: 'brown'
  };

  /* Personen aus dem DOM lesen (Markup = Source of Truth, Playbook §1) */
  function readPersons() {
    var rows = [];
    root.querySelectorAll('#jz-persons .jz-person-row').forEach(function (r) {
      var y = (r.querySelector('.jz-year').value || '').trim();
      var n = (r.querySelector('.jz-name').value || '').trim();
      var cEl = r.querySelector('.jz-person-color');
      rows.push({ year: y, name: n, color: (cEl && cEl.value) || state.c_names || INK, el: r });
    });
    return rows;
  }
  function completePersons() {
    return readPersons().filter(function (p) { return p.year && p.name; });
  }

  /* ===================================================================
   * Render-Bausteine - 1:1-Spiegel von jgText/jgFit (Server print-mode.js)
   * =================================================================== */
  function jzText(grid, o) {
    if (o.content == null || String(o.content).trim() === '') return null;
    var el = document.createElement('div');
    el.className = 'text-slot';
    el.textContent = o.content;
    var css = 'position:absolute;z-index:6;' +
      'left:' + (o.x != null ? o.x : 50) + '%;top:' + o.y + '%;transform:translate(-50%,-50%);' +
      'display:flex;align-items:center;justify-content:center;text-align:center;' +
      'font-family:' + o.font + ';font-weight:' + (o.weight || 400) + ';' +
      'font-size:' + o.size + 'cqw;color:' + (o.color || INK) + ';line-height:' + (o.lh || 1.15) + ';white-space:nowrap;';
    if (o.upper) css += 'text-transform:uppercase;';
    if (o.spacing) css += 'letter-spacing:' + o.spacing + ';';
    el.style.cssText = css;
    grid.appendChild(el);
    return el;
  }

  function jzFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 40) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  /* ===================================================================
   * Live-Render - 1:1-Spiegel von renderJahreszahlen() (Server)
   * =================================================================== */
  function render() {
    if (!stage) return;
    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bg_color);
    grid.style.backgroundColor = state.bg_color;

    var persons = completePersons();
    var rows = Math.max(1, persons.length);
    // Skalierungsformel: 2 Zeilen ~30cqw-Ziffern, 6 Zeilen ~13.7cqw
    var digitSize = Math.min(30, 82 / rows);
    var nameSize = digitSize * 0.42;

    // ---- Zeilen-Block: fuellt die obere Flaeche, space-evenly ----
    var wrap = document.createElement('div');
    wrap.style.cssText = 'position:absolute;left:50%;top:40%;transform:translate(-50%,-50%);' +
      'width:100%;height:64%;display:flex;flex-direction:column;justify-content:space-evenly;' +
      'align-items:center;z-index:2;';
    var nameEls = [];
    persons.forEach(function (p) {
      var row = document.createElement('div');
      row.style.cssText = 'position:relative;display:flex;align-items:center;justify-content:center;line-height:1;';
      var yearEl = document.createElement('span');
      yearEl.textContent = p.year;
      // Ziffern fix in Linotype Didot (wie Mr&Mrs, Dominik 18.07. abends) -
      // Stil-Picker Jahreszahlen ist damit wirkungslos (ggf. spaeter ausbauen)
      yearEl.style.cssText = 'position:relative;z-index:2;' +
        "font-family:'linotype-didot', 'Playfair Display', Georgia, serif;font-weight:400;" +
        'font-size:' + digitSize + 'cqw;color:' + state.year_color + ';letter-spacing:0.04em;line-height:1;';
      var nameEl = document.createElement('span');
      nameEl.textContent = p.name.toLowerCase();
      nameEl.style.cssText = 'position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:3;' +
        // ANSICHT-TEST (Dominik 18.07.): Namen fix in PD Americano (Typekit) statt
        // Stil-Picker - gefaellt es, wird es als Stil-Option verdrahtet, sonst revert.
        "font-family:'pd-americano', cursive;font-weight:400;font-size:" + nameSize + 'cqw;' +
        'color:' + (p.color || state.c_names || INK) + ';white-space:nowrap;line-height:1;';
      row.appendChild(yearEl);
      row.appendChild(nameEl);
      wrap.appendChild(row);
      nameEls.push(nameEl);
    });
    grid.appendChild(wrap);

    // ---- Footer: Herz + Familienname + optionaler Spruch ----
    var heart = document.createElement('div');
    heart.style.cssText = 'position:absolute;left:50%;top:78%;transform:translate(-50%,-50%);width:3.2cqw;z-index:5;';
    heart.innerHTML = '<svg viewBox="0 0 220 200" style="display:block;width:100%;height:auto;">' +
      '<path d="' + JZ_HEART_PATH + '" fill="' + state.year_color + '"/></svg>';
    grid.appendChild(heart);

    var elFamily = jzText(grid, { content: state.family, x: 50, y: 84, font: "'Playfair Display', Georgia, serif", weight: 600, size: 4.2, color: state.c_footer || INK, upper: true, spacing: '0.28em' });
    var elSpruch = jzText(grid, { content: state.spruch, x: 50, y: 88.5, font: SANS, weight: 500, size: 2.2, color: state.c_footer || INK, upper: true, spacing: '0.20em' });

    stage.innerHTML = '';
    stage.appendChild(grid);

    nameEls.forEach(function (el) { jzFit(el, 80); });
    jzFit(elFamily, 88);
    jzFit(elSpruch, 90);
  }

  /* ===================================================================
   * Personen-Zeilen-Editor: + Person (max 6), Entfernen (min 2),
   * Inline-Validierung (Jahr gehoert zu Name - AK aus der Spec).
   * =================================================================== */
  function updatePersonControls() {
    var rows = root.querySelectorAll('#jz-persons .jz-person-row');
    var addBtn = document.getElementById('jz-add-person');
    if (addBtn) addBtn.style.display = rows.length >= MAX_PERSONS ? 'none' : '';
    rows.forEach(function (r) {
      var rm = r.querySelector('.jz-remove');
      if (rm) rm.style.visibility = rows.length <= MIN_PERSONS ? 'hidden' : 'visible';
    });
  }

  function validatePersons(showHint) {
    var hint = document.getElementById('jz-person-hint');
    var invalid = false;
    readPersons().forEach(function (p) {
      var halfFilled = (!!p.year !== !!p.name);
      p.el.querySelector('.jz-year').classList.toggle('jz-invalid', halfFilled && !p.year);
      p.el.querySelector('.jz-name').classList.toggle('jz-invalid', halfFilled && !p.name);
      if (halfFilled) invalid = true;
    });
    if (hint) hint.style.display = (invalid && showHint !== false) ? '' : 'none';
    return !invalid;
  }

  function addPersonRow() {
    var container = document.getElementById('jz-persons');
    if (!container || container.querySelectorAll('.jz-person-row').length >= MAX_PERSONS) return;
    var row = document.createElement('div');
    row.className = 'jz-person-row';
    // Farb-Init: uebernimmt die Farbe der letzten Zeile (haeufig gewollt einheitlich)
    var lastColor = INK;
    var lastEl = container.querySelector('.jz-person-row:last-child .jz-person-color');
    if (lastEl && lastEl.value) lastColor = lastEl.value;
    row.innerHTML = '<input type="text" class="jz-year" maxlength="4" inputmode="numeric" autocomplete="off" placeholder="Jahr">' +
      '<input type="text" class="jz-name" maxlength="15" autocomplete="off" placeholder="Vorname">' +
      '<input type="color" class="jz-color jz-person-color" value="' + lastColor + '" title="Farbe Name" aria-label="Farbe Name">' +
      '<button type="button" class="jz-remove" aria-label="Zeile entfernen">&times;</button>';
    container.appendChild(row);
    updatePersonControls();
    row.querySelector('.jz-year').focus();
  }

  function initPersonsEditor() {
    var container = document.getElementById('jz-persons');
    if (!container) return;
    container.addEventListener('input', function () { validatePersons(true); render(); });
    container.addEventListener('click', function (e) {
      var rm = e.target.closest('.jz-remove');
      if (!rm) return;
      e.preventDefault();
      if (container.querySelectorAll('.jz-person-row').length <= MIN_PERSONS) return;
      rm.closest('.jz-person-row').remove();
      updatePersonControls();
      validatePersons(true);
      render();
    });
    var addBtn = document.getElementById('jz-add-person');
    if (addBtn) addBtn.addEventListener('click', function (e) { e.preventDefault(); addPersonRow(); render(); });
    updatePersonControls();
  }

  /* ===================================================================
   * Eingaben: Familienname, Spruch, Farben
   * =================================================================== */
  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null) state[key] = el.value;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
  }

  function initPresetChips() {
    var chips = root.querySelectorAll('.jz-preset-chips [data-preset]');
    var input = document.getElementById('jz-spruch');
    chips.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var val = c.getAttribute('data-preset') || '';
        if (input) input.value = val;
        state.spruch = val;
        render();
      });
    });
  }

  function initStylePickers() {
    root.querySelectorAll('.pw-style-row[data-style-target]').forEach(function (row) {
      var target = row.getAttribute('data-style-target');
      var btns = row.querySelectorAll('.pw-style-btn[data-style]');
      var cur = row.querySelector('.pw-style-btn.current[data-style]');
      if (cur) state.fstyle[target] = cur.dataset.style;
      btns.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          btns.forEach(function (x) { x.classList.remove('current'); });
          b.classList.add('current');
          state.fstyle[target] = b.dataset.style;
          render();
        });
      });
    });
  }

  function initColorPickers() {
    root.querySelectorAll('.jz-color[data-key]').forEach(function (p) {
      if (p.value) state[p.dataset.key] = p.value;
      p.addEventListener('input', function () { state[p.dataset.key] = p.value; render(); });
    });
  }

  function initPresetSwatches() {
    var swatches = root.querySelectorAll('.jz-preset[data-color]');
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) {
        e.preventDefault();
        swatches.forEach(function (x) { x.classList.remove('current'); });
        s.classList.add('current');
        state.year_color = s.getAttribute('data-color');
        render();
      });
    });
    var active = root.querySelector('.jz-preset.current[data-color]');
    if (active) state.year_color = active.getAttribute('data-color');
  }

  function initPaperColor() {
    var swatches = root.querySelectorAll('.jz-paper[data-color]');
    function setPaper(hex) {
      state.bg_color = hex;
      swatches.forEach(function (s) {
        s.classList.toggle('current', (s.getAttribute('data-color') || '').toLowerCase() === hex.toLowerCase());
      });
      render();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); setPaper(s.getAttribute('data-color')); });
    });
  }

  /* Info-Gluehbirne (Stadt-/Sternkarten-Muster, .tab-help) */
  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          content.style.display = 'none';
          toggle.classList.remove('is-active');
        });
      }
    });
  }

  /* Tabs (Design / Produkt) - main__switcher-Konvention (editor-tabs.css) */
  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current, fallen damit automatisch.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (nur <=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - 1:1 Geburtsposter-/Fotoposter-Schema
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = parsePosterDim(state.paper_size);
    var shortE = Math.min(d.w, d.h), longE = Math.max(d.w, d.h);
    stage.style.setProperty('--collage-aspect', shortE + ' / ' + longE);
    var flat = stage.closest('.jz-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (shortE / longE) + ')';
    render();
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('jz-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }

  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add - Muster geburtsposter.js: Render-Job synchron anstossen,
   * dann /cart/add.js mit _print_image_url + Config-Properties.
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('jz-cart-btn-' + sectionId);
    if (!validatePersons(true)) { alert('Bitte fülle Jahr UND Vorname pro Zeile aus.'); return; }
    var persons = completePersons();
    if (persons.length < MIN_PERSONS) { alert('Bitte trage mindestens 2 Personen ein.'); return; }
    if (!(state.family || '').trim()) { alert('Bitte gib den Familiennamen ein.'); return; }
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var dim = parsePosterDim(state.paper_size);
        var shortEdge = Math.min(dim.w, dim.h), longEdge = Math.max(dim.w, dim.h);
        var cleanPersons = persons.map(function (p) { return { year: p.year, name: p.name, color: p.color }; });

        var payload = {
          product: 'jahreszahlen',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: shortEdge, height: longEdge, dpi: 300 },
          font_styles: state.fstyle,
          bg_color: state.bg_color,
          persons: cleanPersons,
          family: (state.family || '').trim(),
          spruch: (state.spruch || '').trim(),
          year_color: state.year_color,
          c_names: state.c_names || INK,
          c_footer: state.c_footer || INK
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/jahreszahlen/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/jahreszahlen/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Backend nicht erreichbar -> Fallback-URL bleibt */ }

        var props = {
          '_Personen': cleanPersons.map(function (p) { return p.year + ' ' + p.name; }).join(', '),
          '_Familienname': (state.family || '').trim(),
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          '_groesse': state.paper_size,
          '_produkt': 'jahreszahlen'
        };
        if ((state.spruch || '').trim()) props['_Spruch'] = state.spruch.trim();
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[jahreszahlen] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* ===================================================================
   * Init - Input-Values aus dem Markup sind Source of Truth (Playbook §1)
   * =================================================================== */
  function init() {
    root = document.querySelector('.jz-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('jz-stage-' + sectionId);

    bindField('jz-family', 'family');
    bindField('jz-spruch', 'spruch');
    initPersonsEditor();
    initPresetChips();
    initStylePickers();
    initColorPickers();
    initPresetSwatches();
    initPaperColor();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('jz-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
